import React from "react";
import middleware from "./middleware/middleware";
import AllAskTransaction from "../component/sections/finance/AllAskTransaction";
import AddAskTransaction from "../component/sections/finance/AddAskTransaction";
import InfoAskTransaction from "../component/sections/finance/InfoAskTransaction";
import AllWalletLogPosition from "../component/sections/finance/AllWalletLogPosition";
import AllScoreLogPosition from "../component/sections/finance/AllScoreLogPosition";
import AllTransactionScoreToWalletAdvertiser from "../component/sections/finance/AllTransactionScoreToWalletAdvertiser";
import AddTransactionScoreToWalletAdvertiser from "../component/sections/finance/AddTransactionScoreToWalletAdvertiser.jsx";

const sitesRoutes = [
  {
    path: "/finance/ask-transaction/all",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllAskTransaction />,
        "AllAskTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/ask-transaction/add",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AddAskTransaction />,
        "AddAskTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/ask-transaction/info/:askTransactionID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <InfoAskTransaction />,
        "InfoAskTransaction"
      );
    },
    exact: true,
  },
  {
    path: "/finance/all-wallet-log-position",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllWalletLogPosition />,
        "AllWalletLogPosition"
      );
    },
    exact: true,
  },
  {
    path: "/finance/all-score-log-position",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllScoreLogPosition />,
        "AllScoreLogPosition"
      );
    },
    exact: true,
  },
  {
    path: "/finance/all-transaction-score-to-wallet-advertiser",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllTransactionScoreToWalletAdvertiser />,
        "AllTransactionScoreToWalletAdvertiser"
      );
    },
    exact: true,
  },
  {
    path: "/finance/add-transaction-score-to-wallet-advertiser",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AddTransactionScoreToWalletAdvertiser />,
        "AddTransactionScoreToWalletAdvertiser"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
